// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".HDxyabpX8zE1i5efCADw{visibility:visible}.HDxyabpX8zE1i5efCADw.yN4pkRymGm_SAqCNmnqF{visibility:hidden}", "",{"version":3,"sources":["webpack://./src/javalab/javalab-crosshair-overlay.module.scss"],"names":[],"mappings":"AAEA,sBACE,kBAAA,CAEA,2CACE,iBAAA","sourcesContent":["@use \"./constants.module.scss\";\n\n.overlay {\n  visibility: visible;\n\n  &.hidden {\n    visibility: hidden;\n  }\n}\n\n:export {\n  width: constants.$visualization-overlay-width;\n  height: constants.$visualization-overlay-height;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"visualizationWidth": "800px",
	"visualizationHeight": "800px",
	"visualizationOverlayScale": "2",
	"visualizationOverlayWidth": "400px",
	"visualizationOverlayHeight": "400px",
	"width": "400px",
	"height": "400px",
	"overlay": "HDxyabpX8zE1i5efCADw",
	"hidden": "yN4pkRymGm_SAqCNmnqF"
};
export default ___CSS_LOADER_EXPORT___;
